import React from 'react';
import StripeConnectCard from './StripeConnectCard';

const PaymentSettingsForm = ({ venueId, venueDetails = null }) => {
  return (
    <div className="settings-panel payment-settings-panel" style={{ width: '100%' }}>
      <div className="payment-settings-header">
        <h3>Payments</h3>
      </div>
      <div className="payment-settings-content">
        <StripeConnectCard venueId={venueId} venueDetails={venueDetails} />
      </div>
    </div>
  );
};

export default PaymentSettingsForm;
